<script lang="ts">
	import Icon from '../../basic/Icon.svelte';
	import { recentlyUsedDocumentStore } from '../../stores/DocumentViewStore.svelte';
	import type { SelectableDocument } from '../../types/DocumentTypes';
	import { ViewMode } from '../../types/ListTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		item: SelectableDocument;
		viewMode: ViewMode;
	}

	let { item, viewMode }: Props = $props();

	//Was the document just recently opened?
	let recentlyOpened = $derived($recentlyUsedDocumentStore.get(item.id) || null);
</script>

<div class="flex h-9 {viewMode == ViewMode.LIST ? 'flex-wrap h-full' : 'justify-end gap-2'}">
	{#if item.isMigration}
		<div class="holder h-9 w-9 pt-1" class:listview={viewMode == ViewMode.LIST}>
			<p class="font-bold text-lg text-secondary-200 dark:text-secondary-500 text-center">M</p>
		</div>
	{/if}

	{#if item.isRegie}
		<div class="holder" class:listview={viewMode == ViewMode.LIST}>
			<Icon name="clock" classInfo="fill-secondary-200 dark:fill-white" />
		</div>
	{/if}

	<!--Info if document is mobile available-->
	{#if item.isMobileEditable}
		<div class="holder" class:listview={viewMode == ViewMode.LIST}>
			<Icon name="mobile-screen" classInfo="fill-secondary-200 dark:fill-white" />
		</div>
	{/if}

	<!--Info if document is finalize-->
	{#if item.finalizedDate && !item.documentInformation?.cancelDate}
		<div class="holder" class:listview={viewMode == ViewMode.LIST}>
			<Icon
				name="stamp"
				classInfo="fill-secondary-200 dark:fill-white"
				hoverText={$_('documentview.lbl_finalized')}
			/>
		</div>
	{/if}

	<!--Info if document is canceled-->
	{#if item.documentInformation?.cancelDate}
		<div class="holder" class:listview={viewMode == ViewMode.LIST}>
			<Icon name="stamp-slash" classInfo="fill-red" hoverText={$_('documentview.lbl_canceled')} />
		</div>
	{/if}

	<!--Info if some other user watched the document recently-->
	{#if recentlyOpened}
		<div class="holder-recently" class:listview={viewMode == ViewMode.LIST}>
			<Icon
				name="eye"
				hoverText={$_('documentview.lbl_recently_opened').replace(
					'{}',
					recentlyOpened?.lastOpenedLoginName || ''
				)}
			/>
		</div>
	{/if}
</div>

<style>
	.holder :global {

    cursor: default;

    border-top-left-radius: 5px;

    border-top-right-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));

    padding: 0.5rem
}

.holder :global:where(.dark, .dark *) {

    --tw-bg-opacity: 1;

    background-color: rgb(101 101 101 / var(--tw-bg-opacity, 1))
}

	.holder-recently :global {

    cursor: default;

    border-top-left-radius: 5px;

    border-top-right-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));

    fill: #a80727;

    padding: 0.5rem
}

	.holder-recently :global:where(.dark, .dark *) {

    --tw-bg-opacity: 1;

    background-color: rgb(125 125 125 / var(--tw-bg-opacity, 1));

    fill: #ff9800
}

	.holder-recently.listview {

    background-color: transparent
}

	.holder.listview {

    background-color: transparent
}
</style>
